import Api from "./Api";

const endpoint = "/status";
export default {
    get() {
        return Api.fetchData(endpoint);
    },
    getSinger() {
        return Api.fetchData(endpoint + "/singer");
    },
    getChor() {
        return Api.fetchData(endpoint + "/chor");
    },
    getallStati() {
        return Api.fetchData(endpoint + '/all');
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
